export const SUCCESS = 'success'

export const CONTACT = {
    PENDING: 'Pending',
    DONE: 'Done',
    TRANSFER: 'Transfer',
}

export const CONTACT_STATUS = [
    'Pending', 'Done', 'Transfer'
]

export const PRIORITY_STATUS = [
    'Ưu tiên', 'Không ưu tiên', 
]

export const JOB_TAG_STATUS = [
    "Gấp", "Top", "Hot", "Mới",
   
];

export const JOB_SELECT_STATUS = [
    'PENDING', 'REFUSE', 'POSTED', 'INACTIVE'
]
export const PRIORITY_MAP = {
    1: 'Ưu tiên',
    0: 'Không ưu tiên',
    'Ưu tiên': 1,
    'Không ưu tiên': 0,
};

export const PRIORITY_SELECT = [
    { value: 1, label: 'Ưu tiên' },
    { value: 0, label: 'Không ưu tiên' },
]